<template>
  <div id="tableContent">
    <div id="player4">
      <div class="hoverable" >
        <img v-if="table.users[3] && table.users[3].is_bot" id="bot-image" alt="user" :src="require('../assets/bot.jpg')" width="25" height="25"  @click="replaceBot()" />
        <img v-else id="user-image" alt="bot" :src="require('../assets/bot.jpg')" width="25" height="25" />
      </div>
      <div class="player-box" :class="{empty: !table.users[3]}">
        <div id="name-box">
          <h5 class="name" v-if="table.users[3]">{{ truncate(table.users[3].name) }}</h5>
          <h5 v-else>libero</h5>
        </div>
      </div>
    </div>
    <a v-on:click="join(table.id)">
      <div>
        <div id="player1">
          <div class="hoverable" >
            <img v-if="table.users[0] && table.users[0].is_bot" id="bot-image" alt="user" :src="require('../assets/bot.jpg')" width="25" height="25" @click="replaceBot()" />
            <img v-else id="user-image" alt="bot" :src="require('../assets/bot.jpg')" width="25" height="25" />
          </div>
          <div class="player-box" :class="{empty: !table.users[0]}">
            <div id="name-box">
              <h5 class="name" v-if="table.users[0]">{{ truncate(table.users[0].name) }}</h5>
              <h5 v-else>libero</h5>
            </div>
          </div>
        </div>
        <div id="player3">
          <div class="hoverable" >
            <img v-if="table.users[2] && table.users[2].is_bot" id="bot-image" alt="bot" :src="require('../assets/bot.jpg')" width="25" height="25" @click="replaceBot()" />
             <img v-else id="user-image" alt="bot" :src="require('../assets/bot.jpg')" width="25" height="25" />
          </div>
          <div class="player-box" :class="{empty: !table.users[2]}">
            <div id="name-box">
              <h5 class="name" v-if="table.users[2]">{{ truncate(table.users[2].name) }}</h5>
              <h5 v-else>libero</h5>
            </div>
          </div>
        </div>
        <div
          id="table"
          :class="{active : table.id == tableActive.id, hoverable: !table.users[4] && user.id}"
        >
          <h4 id="tableName">{{ table.name }}</h4>
          <img
            id="imgCard"
            :src="require('../assets/cards/' + table.card_type + '/Ah.png')"
            width="35"
            height="65"
          />
        </div>
        <div id="player5">
          <div class="player-box" :class="{empty: !table.users[4]}">
            <div id="name-box">
              <h5 class="name" v-if="table.users[4]">{{ truncate(table.users[4].name) }}</h5>
              <h5 v-else>libero</h5>
            </div>
          </div>
          <div class="hoverable" >
            <img v-if="table.users[4] && table.users[4].is_bot" id="bot-image-5" alt="bot" :src="require('../assets/bot.jpg')" width="25" height="25" @click="replaceBot()" />
            <img v-else id="user-image" alt="bot" :src="require('../assets/user.jpg')" width="25" height="25" />
          </div>
        </div>
      </div>
    </a>
    <div id="player2">
      <div class="hoverable" >
        <img v-if="table.users[1] && table.users[1].is_bot" id="bot-image" alt="bot" :src="require('../assets/bot.jpg')" width="25" height="25" @click="replaceBot()" />
        <img v-else id="user-image" alt="bot" :src="require('../assets/user.jpg')" width="25" height="25" />
      </div>
      <div class="player-box" :class="{empty: !table.users[1]}">
        <div id="name-box">
          <h5 class="name" v-if="table.users[1]">{{ truncate(table.users[1].name) }}</h5>
          <h5 v-else>libero</h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from "@/router";
import { mapGetters } from "vuex";

export default {
  name: "TableGame",
  props: {
    table: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clicked: false
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      tableActive: "tables/tableActive",
      audioSetting: "audioSetting"
    })
  },
  methods: {
    join() {
      if (this.clicked){
        return;
      }
      this.clicked = true;
      if (!this.user.id) {
        return;
      }
      if (this.table.id == this.tableActive.id) {
        router.push("/room");
        return;
      }
      if (this.table.users[4]) {
        this.replaceBot();
        return;
      }
      this.$emit("join", this.table.id);
      this.clicked = false;
    },
    truncate(name) {
      if (name.length <= 11) {
        return name;
      }
      return name.substring(0, 9) + "...";
    },
    replaceBot() {
      if (this.clicked) {
        return;
      }
      this.clicked = true
      if (this.tableActive.id && this.tableActive.id != this.table.id) {
        window.Echo.channel("table-" + this.tableActive.id).stopListening(
          "GameStartEvent"
        );
        const payload = {
          userId: this.user.id
        };
        if (this.table.queue.findIndex(userQueue => userQueue.id == this.user.id) != -1) {
          this.$store.dispatch("tables/removeMeFromQueue", payload);
        }
        this.$store.dispatch("tables/leaveTable", payload).then(result => {
          if (!result) {
            const userData = {
              userId: this.user.id
            };
            this.$store.dispatch("user/deleteUser", userData).then(() => {
              this.$store.commit("call/resetCall");
              this.$store.commit("game/exit");
              this.$store.commit("chat/resetChat");
              this.$store.commit("results/resetResults");
              router.push("/");
            });
          } else {
            this.replaceBotAction()
          }
        });
      } else {
        this.replaceBotAction();
      }
    },
    replaceBotAction() {
      const payload = {
        user: this.user,
        tableId: this.table.id
      }
      this.$store.dispatch("tables/replaceBot", payload).then(response=>{
          if (response) {
            window.Echo.channel("table-" + this.table.id).listen("GameStartEvent", e => {
              const payload = {
                user: this.user,
                tableId: this.table.id
              }
              this.$store.commit("tables/addUserToTableById", payload);
              this.$store.commit("tables/resetQueue");
              if (this.audioSetting) {
                var audio = new Audio(require("../assets/audio/start.mp3"));
                audio.play();
              }
              this.$store.commit("game/resetCards");
              this.$store.dispatch("game/retrieveGameData", e);
            });
          }
          this.clicked = false
        })
    }
  }
};
</script>
<style scoped>
#tableContent {
  display: flex;
  margin-bottom: 6em;
}
#table {
  position: relative;
  width: 108px;
  box-sizing: content-box;
  border-width: 100px 36px 0;
  border-style: solid;
  border-color: rgb(255, 153, 0) transparent;
}
#table:before {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  top: -170px;
  left: -36px;
  border-width: 0 90px 70px;
  border-style: solid;
  border-color: transparent transparent rgb(255, 153, 0);
}
#tableName {
  font-weight: 800;
  position: absolute;
  margin-top: -7.5em;
  color: black;
  width: inherit;
  z-index: 2;
}
#imgCard {
  position: absolute;
  margin-top: -4.5em;
  margin-left: -1em;
}
.active {
  border-color: rgb(255, 89, 0) transparent !important;
}
.active:before {
  border-color: transparent transparent rgb(255, 89, 0) !important;
}
.hoverable:hover {
  border-color: rgb(255, 204, 0) transparent !important;
  cursor: pointer;
}
.hoverable:hover:before {
  border-color: transparent transparent rgb(255, 204, 0) !important;
  cursor: pointer;
}
#playButton {
  position: absolute;
  margin-top: -6em;
  width: inherit;
}
.player-box {
  border-radius: 5px;
  background-color: black;
  color: antiquewhite;
}
.empty {
  background-color: antiquewhite;
  color: black;
}

#player1 {
  transform: translateX(-36%) translateY(+17%) rotate(-38deg);
  display: flex;
  flex-direction: column;
  align-items: center;
}

#player2 {
  align-self: center;
  transform: translateX(-33%) translateY(57%) rotate(110deg);
}

#player3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateX(36%) translateY(-79%) rotate(+38deg);
}

#player4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateX(+134%) translateY(-2%) rotate(251deg);
}

#player5 {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 0.5em;
}
.player-box {
  width: 6em;
}
#bot-image {
  margin-bottom: 4px;
}
#bot-image-5 {
  margin-top: 4px;
  transform: rotate(180deg);
}
#user-image {
  visibility: hidden;
}
</style>
